/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyErrorIcon = createIcon("EmptyErrorIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#FBCFC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m53.715 36.858 26.468 44.113A2 2 0 0178.468 84H25.532a2 2 0 01-1.715-3.029l26.468-44.113a2 2 0 013.43 0Z",
    fill: "#FF946A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m62.715 31.858 26.468 44.113A2 2 0 0187.468 79H34.532a2 2 0 01-1.714-3.029l26.467-44.113a2 2 0 013.43 0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 47a1.994 1.994 0 011.99 2.11l-.878 14.949a1 1 0 01-.998.941h-.228a1 1 0 01-.998-.941L59.01 49.11A1.994 1.994 0 0161 47Z",
    fill: "#DE4E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 71a2 2 0 100-4 2 2 0 000 4Z",
    fill: "#DE4E31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.03 31.172a2 2 0 01.685.686l26.468 44.113A2 2 0 0187.468 79H34.532a2 2 0 01-1.714-3.029l26.467-44.113a2 2 0 012.744-.686Zm-1.544 2.801a1 1 0 00-.343.343L35.44 75.486A1 1 0 0036.3 77h49.4a1 1 0 00.858-1.514l-24.701-41.17a1 1 0 00-1.372-.343Z",
    fill: "#DE4E31"
  }));
}, {
  "i18nKey": "svg.EmptyErrorIcon"
});